/**
 * Reads a class-validator rejection back onto the form.
 *
 * Nest answers 400 with `message: string[]`, each beginning with the property name
 * ("legalName must be longer than…"), except where the DTO wrote its own message - those
 * are matched by `aliases`. What matches no field goes to the summary. A request that got
 * no answer at all returns null: that is a network failure, the one case for a toast.
 */
export const readServerErrors = (
  error: any,
  fields: string[],
  aliases: Record<string, string> = {}
): { fields: Record<string, string>; other: string[] } | null => {
  if (!error?.response) return null;
  const raw = error.response.data?.message;
  const messages: string[] = Array.isArray(raw) ? raw : raw ? [String(raw)] : [];
  const result = { fields: {} as Record<string, string>, other: [] as string[] };
  messages.forEach(message => {
    const alias = Object.keys(aliases).find(prefix => message.startsWith(prefix));
    const field = fields.find(name => message.startsWith(`${name} `) || message.startsWith(`${name}.`)) ?? (alias ? aliases[alias] : undefined);
    if (field && !result.fields[field]) result.fields[field] = message;
    else result.other.push(message);
  });
  return result;
};
